angular.module('impactx.vendor').controller('VendorCtrl', VendorCtrl);
VendorCtrl.$inject = [
    '$scope',
    'dataGen',
    '$routeParams',
    'BackService',
    '$mdToast',
    'ConfirmationService',
    'ToolbarService'
];

function VendorCtrl($scope, dataGen, $routeParams, BackService, $mdToast, ConfirmationService, ToolbarService) {
    var ctrl = this;
    var id = $routeParams.id;

    ctrl.save = function (event) {
        var dataObj = {
            vendor: $scope.data
        };
        return dataGen.postAsForm($scope, dataObj, "/vendor/save").then(function () {
            BackService.back();
            $mdToast.show(
                $mdToast.simple()
                    .textContent($scope.trns.saveSuccess)
                    .position("bottom right")
                    .hideDelay(10000)
            );
        });
    };

    ctrl.deleteDialog = function (event) {
        ConfirmationService.showConfirmationDialog(deleteVendor, event, $scope.trns.confirmDelete,
            $scope.trns.delete, $scope.trns.abort);
    };

    var deleteVendor = function () {
        var result = {};
        return dataGen.postAsForm(result, {id: id}, '/vendor/delete').then(function () {
            BackService.back();
        });
    };

    var init = function () {
        dataGen.getData($scope, {id: id}, '/vendor/view').then(function () {
            defineButtons();
        });
    };
    init();

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: ctrl.save,
                type: 'validation',
                condition: isEditable,
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.trns.delete,
                action: ctrl.deleteDialog,
                type: 'dialogaction',
                condition: canDelete
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function isEditable() {
        return !$scope.data.readOnly;
    }

    function canDelete() {
        return isEditable() && $scope.data.id > 0;
    }
}
